import React from "react";

const StaffProfile = ()=>{
    return(
        <div>
            <h2>Staff Dashboard is under develop, will see the profile soon</h2>
        </div>
    )
}
export default StaffProfile;